import {useQuery} from "react-query";
import ShipmentDetailsApi from "./Shipment.ShipmentDetails.api";

export function useShipmentDetailsData(referenceNumber:any){
    return useQuery(["fetchShipmentDetailsData", referenceNumber], ShipmentDetailsApi.getShipmentDetailsData);
}

export function useContainerDetailsData(query:any) {
    return useQuery(["fetchContainerDetailsData", query], ShipmentDetailsApi.getContainerDetailsData);
}

export function useShipmentContainersData(referenceNumber:any) {
    return useQuery(["fetchShipmentContainerDetailsData", referenceNumber], ShipmentDetailsApi.getContainersByShipmentId);
}